export default __webpack_public_path__ + "static/media/CompletedEffect.b461f47f.mp3";